// Converted to lazy loading
const safesIndex = () => import('@/pages/safes/safes/index.vue')
const safesForm = () => import('@/pages/safes/safes/form.vue')
const safesShow = () => import('@/pages/safes/safes/show.vue')
const FinancialDependantIndex = () => import('@/pages/safes/financialDependents/index.vue')
const FinancialDependantForm = () => import('@/pages/safes/financialDependents/form.vue')
const FinancialDependentsShow = () => import('@/pages/safes/financialDependents/show.vue')

const bankAccountsIndex = () => import('@/pages/safes/bankAccounts/index.vue')
const bankAccountsForm = () => import('@/pages/safes/bankAccounts/form.vue')
const bankAccountsShow = () => import('@/pages/safes/bankAccounts/show.vue')

const salesPaymentsIndex = () => import('@/pages/safes/salesPayments/index.vue')
const salesPaymentsForm = () => import('@/pages/safes/salesPayments/form.vue')
const salesPaymentsShow = () => import('@/pages/safes/salesPayments/show.vue')

const purchasePaymentsIndex = () => import('@/pages/safes/purchasePayments/index.vue')
const purchasePaymentsForm = () => import('@/pages/safes/purchasePayments/form.vue')
const purchasePaymentsShow = () => import('@/pages/safes/purchasePayments/show.vue')

const expensesIndex = () => import('@/pages/safes/expenses/index.vue')
const expensesForm = () => import('@/pages/safes/expenses/form.vue')
const expensesShow = () => import('@/pages/safes/expenses/show.vue')
const regularExpensesIndex = () => import('@/pages/safes/regularExpenses/index.vue')
const regularExpensesForm = () => import('@/pages/safes/regularExpenses/form.vue')
const regularExpensesShow = () => import('@/pages/safes/regularExpenses/show.vue')

const incomesIndex = () => import('@/pages/safes/incomes/index.vue')
const incomesForm = () => import('@/pages/safes/incomes/form.vue')
const incomesShow = () => import('@/pages/safes/incomes/show.vue')

const safesDepositsIndex = () => import('@/pages/safes/safesDeposits/index.vue')
const safesDepositsForm = () => import('@/pages/safes/safesDeposits/form.vue')
const safesDepositsShow = () => import('@/pages/safes/safesDeposits/show.vue')

const safesWithdrawalsIndex = () => import('@/pages/safes/safesWithdrawals/index.vue')
const safesWithdrawalsForm = () => import('@/pages/safes/safesWithdrawals/form.vue')
const safesWithdrawalsShow = () => import('@/pages/safes/safesWithdrawals/show.vue')

const safesTransfersIndex = () => import('@/pages/safes/safesTransfers/index.vue')
const safesTransfersForm = () => import('@/pages/safes/safesTransfers/form.vue')
const safesTransfersShow = () => import('@/pages/safes/safesTransfers/show.vue')

const safesSettlementsIndex = () => import('@/pages/safes/safesSettlements/index.vue')
const safesSettlementsForm = () => import('@/pages/safes/safesSettlements/form.vue')
const safesSettlementsShow = () => import('@/pages/safes/safesSettlements/show.vue')

const taxesIndex = () => import('@/pages/safes/taxPayments/index.vue')
const taxesForm = () => import('@/pages/safes/taxPayments/form.vue')
const taxesShow = () => import('@/pages/safes/taxPayments/show.vue')
const routes = [
  //safes routes

  {
    path: 'safes',
    name: 'safes',
    component: safesIndex
  },
  {
    path: 'safes/create',
    name: 'safesCreate',
    component: safesForm
  },
  {
    path: 'safes/:id/edit',
    name: 'safesEdit',
    component: safesForm
  },

  {
    path: 'safes/:id',
    name: 'safesShow',
    component: safesShow
  },
  {
    path: 'financialDependents',
    name: 'financialDependents',
    component: FinancialDependantIndex
  },

  {
    path: 'financialDependents/create',
    name: 'financialDependentsCreate',
    component: FinancialDependantForm
  },
  {
    path: 'financialDependents/:id/edit',
    name: 'financialDependentsEdit',
    component: FinancialDependantForm
  },

  {
    path: 'financialDependents/:id',
    name: 'financialDependentsShow',
    component: FinancialDependentsShow
  },
  //bankAccounts routes

  {
    path: 'bankAccounts',
    name: 'bankAccounts',
    component: bankAccountsIndex
  },
  {
    path: 'bankAccounts/create',
    name: 'bankAccountsCreate',
    component: bankAccountsForm
  },
  {
    path: 'bankAccounts/:id/edit',
    name: 'bankAccountsEdit',
    component: bankAccountsForm
  },

  {
    path: 'bankAccounts/:id',
    name: 'bankAccountsShow',
    component: bankAccountsShow
  },

  // salesPayments routes

  {
    path: 'salesPayments',
    name: 'salesPayments',
    component: salesPaymentsIndex
  },
  {
    path: 'salesPayments/create',
    name: 'salesPaymentsCreate',
    component: salesPaymentsForm
  },
  {
    path: 'salesPayments/:id/edit',
    name: 'salesPaymentsEdit',
    component: salesPaymentsForm
  },
  {
    path: 'salesPayments/:id',
    name: 'salesPaymentsShow',
    component: salesPaymentsShow
  },

  // purchasePayments routes

  {
    path: 'purchasePayments',
    name: 'purchasePayments',
    component: purchasePaymentsIndex
  },
  {
    path: 'purchasePayments/create',
    name: 'purchasePaymentsCreate',
    component: purchasePaymentsForm
  },
  {
    path: 'purchasePayments/:id/edit',
    name: 'purchasePaymentsEdit',
    component: purchasePaymentsForm
  },
  {
    path: 'purchasePayments/:id',
    name: 'purchasePaymentsShow',
    component: purchasePaymentsShow
  },

  // expenses routes

  {
    path: 'expenses',
    name: 'expenses',
    component: expensesIndex
  },
  {
    path: 'expenses/create',
    name: 'expensesCreate',
    component: expensesForm
  },
  {
    path: 'expenses/:id/edit',
    name: 'expensesEdit',
    component: expensesForm
  },
  { path: 'expenses/:id', name: 'expensesShow', component: expensesShow },

  {
    path: 'regularExpenses',
    name: 'regularExpenses',
    component: regularExpensesIndex
  },
  {
    path: 'regularExpenses/create',
    name: 'regularExpensesCreate',
    component: regularExpensesForm
  },
  {
    path: 'regularExpenses/:id/edit',
    name: 'regularExpensesEdit',
    component: regularExpensesForm
  },
  { path: 'regularExpenses/:id', name: 'regularExpensesShow', component: regularExpensesShow },

  // incomes routes

  {
    path: 'incomes',
    name: 'incomes',
    component: incomesIndex
  },
  {
    path: 'incomes/create',
    name: 'incomesCreate',
    component: incomesForm
  },
  {
    path: 'incomes/:id/edit',
    name: 'incomesEdit',
    component: incomesForm
  },
  { path: 'incomes/:id', name: 'incomesShow', component: incomesShow },

  // safesDeposits routes

  {
    path: 'safesDeposits',
    name: 'safesDeposits',
    component: safesDepositsIndex
  },
  {
    path: 'safesDeposits/create',
    name: 'safesDepositsCreate',
    component: safesDepositsForm
  },
  {
    path: 'safesDeposits/:id/edit',
    name: 'safesDepositsEdit',
    component: safesDepositsForm
  },
  {
    path: 'safesDeposits/:id',
    name: 'safesDepositsShow',
    component: safesDepositsShow
  },

  //safesWithdrawals routes
  {
    path: 'safesWithdrawals',
    name: 'safesWithdrawals',
    component: safesWithdrawalsIndex
  },
  {
    path: 'safesWithdrawals/create',
    name: 'safesWithdrawalsCreate',
    component: safesWithdrawalsForm
  },
  {
    path: 'safesWithdrawals/:id/edit',
    name: 'safesWithdrawalsEdit',
    component: safesWithdrawalsForm
  },
  {
    path: 'safesWithdrawals/:id',
    name: 'safesWithdrawalsShow',
    component: safesWithdrawalsShow
  },

  // safesTransfers routes

  {
    path: 'safesTransfers',
    name: 'safesTransfers',
    component: safesTransfersIndex
  },
  {
    path: 'safesTransfers/create',
    name: 'safesTransfersCreate',
    component: safesTransfersForm
  },
  {
    path: 'safesTransfers/:id/edit',
    name: 'safesTransfersEdit',
    component: safesTransfersForm
  },
  {
    path: 'safesTransfers/:id',
    name: 'safesTransfersShow',
    component: safesTransfersShow
  },
  {
    path: 'safesSettlements',
    name: 'safesSettlements',
    component: safesSettlementsIndex
  },
  {
    path: 'safesSettlements/create',
    name: 'safesSettlementsCreate',
    component: safesSettlementsForm
  },
  {
    path: 'safesSettlements/:id/edit',
    name: 'safesSettlementsEdit',
    component: safesSettlementsForm
  },
  {
    path: 'safesSettlements/:id',
    name: 'safesSettlementsShow',
    component: safesSettlementsShow
  },
  {
    path: 'taxPayments',
    name: 'taxPayments',
    component: taxesIndex
  },
  {
    path: 'taxPayments/create',
    name: 'taxPaymentsCreate',
    component: taxesForm
  },
  {
    path: 'taxPayments/:id/edit',
    name: 'taxPaymentsEdit',
    component: taxesForm
  },
  { path: 'taxPayments/:id', name: 'taxPaymentsShow', component: taxesShow }
]

export default routes
